import { render, staticRenderFns } from "./kartdialogs.vue?vue&type=template&id=48858c79&scoped=true&"
import script from "./kartdialogs.vue?vue&type=script&lang=js&"
export * from "./kartdialogs.vue?vue&type=script&lang=js&"
import style0 from "./kartdialogs.vue?vue&type=style&index=0&id=48858c79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48858c79",
  null
  
)

export default component.exports